import type { IconData } from '@stacksjs/iconify-core'

export const iFirstAid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M62.321 20.418H42.908V1.005h-22.34v19.413H1.155v22.339h19.413V62.17h22.34V42.757h19.413z\"/>",
  "width": 63,
  "height": 64,
  "viewBox": "0 0 63 64"
}

export default iFirstAid
